module.exports = __webpack_public_path__ + "9779d9a1/img/delete-icon.eb7de062.svg";